import * as Yup from 'yup';

export const addZipCodeSchema = Yup.object({
  zipCode: Yup.string().required('Zip is required').matches(/^[A-Za-z0-9]{5,}$/, 'Zip code must be at least 5 characters without spaces'),
  stateCode: Yup.string().required('State Code is required').matches(/^[A-Za-z0-9]{2,}$/, 'State code must be at least 2 characters'),
  cityCode: Yup.string().required('City is required'),
  countryCode: Yup.string().required('Country is required'),
});
